import { FunctionComponent, useState } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './releaseOccasionalSlot.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, LockOpen } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import UserInput from '@/components/_custom/UserInput/userInput'
import { OccasionalSlotReducer } from '../../showEvent/showOccasionalSlot/showOccasionalSlotDialog'
import { RELEASE_OCCASIONAL_SLOT } from '@/modules/API/slot/occasionalSlotHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ReleaseOccasionalSlotDialogProps {
    open: boolean
    handleClose: () => void
    occasionalSlots: OccasionalSlotReducer[]
    daycareId: number
    refetchData: () => void
    closeParentDialog?: () => void
}

const ReleaseOccasionalSlotDialog: FunctionComponent<ReleaseOccasionalSlotDialogProps> = ({
    open,
    handleClose,
    occasionalSlots,
    daycareId,
    refetchData,
    closeParentDialog
}) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [slotsNumber, setSlotsNumber] = useState<string>(occasionalSlots.length.toString())

    const [releaseOccasionalSlot, { loading: loadingRelease }] = useMutation(RELEASE_OCCASIONAL_SLOT, {
        variables: {
            daycare_id: daycareId,
            occasionalSlots: occasionalSlots.map((occasionalSlot) => occasionalSlot.id).slice(0, parseInt(slotsNumber))
        },
        onCompleted: () => {
            refetchData()
            if (closeParentDialog) {
                closeParentDialog()
            }
            handleClose()

            showNotificationSuccess(t('slotsReleased'))
        },
        onError: () => {
            showNotificationError(t('errorReleasedSlots'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={occasionalSlots.length > 1 ? t('liberatedSlots') : t('releaseOccasionalSlot')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>
                    {occasionalSlots.length > 1
                        ? t('releaseOccasionalSlotsMessage')
                        : t('releaseOccasionalSlotMessage')}
                </p>
                {occasionalSlots.length > 1 && (
                    <UserInput
                        type={'number'}
                        verify={'number'}
                        label={t('seatsNumber')}
                        value={slotsNumber}
                        setValue={setSlotsNumber}
                        className={styles.UserInput}
                        maxNumber={occasionalSlots.length}
                        minNumber={1}
                    />
                )}
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<LockOpen />}
                        onClick={releaseOccasionalSlot}
                        className={styles.Button}
                        disabled={loadingRelease}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ReleaseOccasionalSlotDialog
